import { render, staticRenderFns } from "./PsGallery.vue?vue&type=template&id=4fdf4f17&scoped=true&"
import script from "./PsGallery.vue?vue&type=script&lang=js&"
export * from "./PsGallery.vue?vue&type=script&lang=js&"
import style0 from "./PsGallery.vue?vue&type=style&index=0&id=4fdf4f17&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdf4f17",
  null
  
)

export default component.exports